import React, { useRef} from 'react'
import { FindProspectURL } from '../../Functions/AIFunctions/FindProspect'
import FocusHK from '../../Functions/Hotkeys/FocusHK'

function SearchProspect({
    setShowSearching, 
    setProfile,
    auth,
    fbProfile,
    setFoundInts,
    setInterests,
    setDocId,
    setContentGen,
    setError,
    url,
    setURL,
    setIntVal,
    setEmail
}) {

    const useFocus = () => {
        const htmlElRef = useRef(null)
        const setFocus = () => {htmlElRef.current.focus()}
    
        return [ htmlElRef, setFocus ] 
    }

    const [ inputRef, setInputFocus ] = useFocus()

    const handleSearch = () =>{
        setShowSearching(true)
        setError('')
        setProfile('')
        setIntVal('')
        //insert function here to search for prospect and spit it back out so we can set profile and interests and all that jazz
        FindProspectURL(
            url,
            setShowSearching, 
            setProfile,
            auth,
            fbProfile,
            setFoundInts,
            setInterests,
            setDocId,
            setContentGen,
            setError,
            setEmail
        )
    }

    const handleEnterKey = (e) =>{
        if(e.key === 'Enter'){
            handleSearch()
        }
    }

    return (
        <div className="sm:rounded-lg mt-2"
        style={{width: 400}}
        >
            <FocusHK 
            setInputFocus={setInputFocus}
            />
            <div className="flex">
                <input
                    type="text"
                    name="text"
                    id="text"
                    className="focus:bg-white px-2 py-0.5 focus:outline-none focus:ring border-2 border-indigo-200 focus:border-indigo-300 block w-full sm:text-sm border-gray-700 border-0 rounded-md"
                    placeholder="Linkedin URL"
                    onChange={(e) => setURL(e.target.value)}
                    onKeyDown={(e) => handleEnterKey(e)}
                    ref={inputRef}
                />
                <button 
                    className="bg-blue-500 hover:bg-blue-700 text-white font-semibold py-1 px-2 rounded ml-4 focus:outline-none focus:ring focus:border-indigo-300 disabled:opacity-50"
                    onClick={() => handleSearch()}
                    disabled={url === '' ? true : false}
                >
                    Search
                </button>
            </div>
        </div>
    )
}

export default SearchProspect
